/**
 * @param {array<{slug: string, name: string}>} clients
 * @param string filter
 */
export default function filterClients(clients, filter) {
    const f = filter.toLowerCase();

    return clients.filter(
        client =>
            client.slug.includes(f) || client.name.toLowerCase().includes(f),
    );
}
